import Admin from './Admin';

export default Admin
export { Admin as Base }